<script>
    export default {
        props: ['redirectUrl', 'subEnabled', 'subDefault', 'cloudpaymentData'],
        name: 'payment-form',
        data () {
            return {
                checkedMethod: 'bankCards',
                subscribe: false,
                isSubsEnabled: false
            }
        },
        created() {
            this.subscribe = this.subDefault === '1';
            this.isSubsEnabled = this.subEnabled === '1';
            this.cloudpaymentData = JSON.parse(this.cloudpaymentData);
        },
        mounted() {
            let script = document.createElement('script')
            script.setAttribute('src', 'https://widget.cloudpayments.ru/bundles/cloudpayments')
            document.head.appendChild(script)
        },
        methods: {
            submitForm(event) {
                if (this.checkedMethod === 'bankCards') {
                    this.showCloudPaymentsModal();
                } else {
                    event.target.submit();
                }
            },
            showCloudPaymentsModal() {
                let cpWidget = new cp.CloudPayments({language: this.cloudpaymentData.locale});
                let data = {
                    phone: this.cloudpaymentData.phone,
                    subscribe: this.subscribe ? 1 : 0
                };
                cpWidget.pay('auth',
                    {
                        publicId: this.cloudpaymentData.cpKey,
                        description: this.cloudpaymentData.description,
                        amount: this.cloudpaymentData.amount,
                        currency: this.cloudpaymentData.currency,
                        invoiceId: this.cloudpaymentData.invoiceId,
                        accountId: this.cloudpaymentData.accountId,
                        email: this.cloudpaymentData.email,
                        skin: "modern",
                        data: data
                    },
                {
                    onSuccess: function (options) {
                        window.location.href='/';
                    },
                    onFail: function (reason, options) {
                        console.log('fail');
                    },
                    onComplete: function (paymentResult, options) {
                        //Вызывается как только виджет получает от api.cloudpayments ответ с результатом транзакции.
                        console.log('complete');
                    }
                }
            )
            }
        }
    }
</script>
<template>
    <form method="post" :action="redirectUrl" id="paymentForm" @submit.prevent="submitForm">

        <h2>Варианты оплаты:</h2>
        <label class="radio payform"><input type="radio" name="method" v-model="checkedMethod" value="bankCards"/><span>{{$t('lang.bill.bank_cards')}}</span></label>
        <label class="radio payform"><input type="radio" name="method" v-model="checkedMethod" value="onlineWallets"/><span>{{$t('lang.bill.online_wallets')}}</span></label>
        <p></p>
        <div v-if="isSubsEnabled">
            <label class="radio"><input type="checkbox" v-model="subscribe" id="subscription"/><span>{{ $t('lang.bill.subscription') }}</span></label>
            <a :href="'/' + $t('lang.bill.help_url')" target="_blank">{{ $t('lang.bill.info') }}</a>
        </div>

        <input type="submit" :value="$t('lang.bill.to_pay')">
    </form>
</template>

<style scoped>
.radio {
    width: inherit;
}
.radio.payform {
    padding-left: 20px;
    line-height: 3em;
}
.radio.payform > span {
    font-size: 16px;
    font-weight: 300;
}
</style>
